import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAIRankingNFTsService,
  getAllNFTsService,
  getCategoriesService,
  getFeaturedCollectionsService,
  getFeaturedNFTsService,
  getFilteredNFTsService,
} from "../../apiService/marketplace";
import { getTrendingCollectionService } from "../../apiService/home";

interface NFTsPayload {
  limit?: number;
  page?: number;
}

interface FilteredNFTsPayload {
  limit: number;
  page: number;
  name: string;
  blockchain_network: string;
  rank_by: string;
  category_id: string;
  eco_category_id: string;
}

interface TrendingCollectionPayload {
  page: number;
  limit: number;
  duration: string;
}

export const getAllNFTs = createAsyncThunk(
  "vyga/getAllNFTs",
  async ({ limit, page }: NFTsPayload, { rejectWithValue }) => {
    try {
      const result = await getAllNFTsService(limit, page);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getFeaturedCollections = createAsyncThunk(
  "vyga/getFeaturedCollections",
  async ({ limit, page }: NFTsPayload, { rejectWithValue }) => {
    try {
      const result = await getFeaturedCollectionsService(limit, page);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTrendingCollection = createAsyncThunk(
  "vyga/getTrendingCollection",
  async (
    { page, limit, duration }: TrendingCollectionPayload,
    { rejectWithValue }
  ) => {
    try {
      const result = await getTrendingCollectionService(page, limit, duration);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// not used
export const getAIRankingNFTs = createAsyncThunk(
  "vyga/getAIRankingNFTs",
  async ({ limit, page }: NFTsPayload, { rejectWithValue }) => {
    try {
      const result = await getAIRankingNFTsService(limit, page);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getFeaturedNFTs = createAsyncThunk(
  "vyga/getFeaturedNFTs",
  async (_, { rejectWithValue }) => {
    try {
      const result = await getFeaturedNFTsService();
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getFilteredNFTs = createAsyncThunk(
  "vyga/getFilteredNFTs",
  async (
    {
      limit,
      page,
      name,
      blockchain_network,
      rank_by,
      category_id,
      eco_category_id,
    }: FilteredNFTsPayload,
    { rejectWithValue }
  ) => {
    try {
      const result = await getFilteredNFTsService(
        limit,
        page,
        name,
        blockchain_network,
        rank_by,
        category_id,
        eco_category_id
      );
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCategories = createAsyncThunk(
  "vyga/getCategories",
  async (_, { rejectWithValue }) => {
    try {
      const result = await getCategoriesService();
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
